import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "indicator" }
const _hoisted_2 = { class: "indicator__wrapper" }
const _hoisted_3 = { class: "indicator__avatars" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AvatarWrapper = _resolveComponent("AvatarWrapper")

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.visibleParticipants, (participant, index) => {
          return (_openBlock(), _createBlock(_component_AvatarWrapper, {
            id: participant.actorId,
            key: index,
            token: $props.token,
            name: participant.displayName,
            source: participant.actorType,
            size: $setup.AVATAR.SIZE.EXTRA_SMALL,
            condensed: "",
            "condensed-overlap": 8,
            "disable-menu": "",
            "disable-tooltip": ""
          }, null, 8, ["id", "token", "name", "source", "size"]))
        }), 128))
      ]),
      _createElementVNode("p", {
        class: "indicator__main",
        innerHTML: $options.indicatorMessage
      }, null, 8, _hoisted_4)
    ])
  ], 512)), [
    [_vShow, $options.showIndicatorMessage]
  ])
}